import { Input } from '@/components/ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import type { IUserFilters } from '@/@types/superadmin';

interface IUserFiltersBarProps {
  // LOCAL_TYPE_JUSTIFIED: component props interface
  filters: IUserFilters;
  onFiltersChange: (filters: IUserFilters) => void;
  orgs: Array<{ _id: string; name: string }>;
}

export function UserFiltersBar({ filters, onFiltersChange, orgs }: IUserFiltersBarProps) {
  return (
    <div className="flex items-center gap-3 px-6 py-3 border-b border-border">
      <Input
        placeholder="Search by name or email..."
        value={filters.search}
        onChange={e => onFiltersChange({ ...filters, search: e.target.value })}
        className="max-w-xs"
      />
      <Select
        value={filters.orgId || 'all'}
        onValueChange={v => onFiltersChange({ ...filters, orgId: v === 'all' ? '' : v })}
      >
        <SelectTrigger className="w-48">
          <SelectValue placeholder="All Organisations" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Organisations</SelectItem>
          {orgs.map(org => (
            <SelectItem key={org._id} value={org._id}>
              {org.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Select
        value={filters.role || 'all'}
        onValueChange={v => onFiltersChange({ ...filters, role: v === 'all' ? '' : v })}
      >
        <SelectTrigger className="w-36">
          <SelectValue placeholder="All Roles" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Roles</SelectItem>
          <SelectItem value="owner">Owner</SelectItem>
          <SelectItem value="admin">Admin</SelectItem>
          <SelectItem value="member">Member</SelectItem>
          <SelectItem value="company_user">Company User</SelectItem>
        </SelectContent>
      </Select>
      <Select
        value={filters.status || 'all'}
        onValueChange={v => onFiltersChange({ ...filters, status: v === 'all' ? '' : v })}
      >
        <SelectTrigger className="w-32">
          <SelectValue placeholder="All Status" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Status</SelectItem>
          <SelectItem value="active">Active</SelectItem>
          <SelectItem value="blocked">Blocked</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
